import {createContext} from 'react'
import type React from 'react'

export type PricingRenderer = 'default' | 'v2'

export const PricingRendererContext = createContext<PricingRenderer>('default')

type Props = {
  value: PricingRenderer
  children: React.ReactNode
}

export function PricingRendererProvider({value, children}: Props) {
  return <PricingRendererContext value={value}>{children}</PricingRendererContext>
}
